import {
  getYear,
  setYear,
  setISODay,
  setISOWeek,
  isBefore,
  isAfter,
  isEqual,
  startOfDay,
} from "date-fns"

// This logic is based on logic for the analytics in web booking
// TODO: Check if possible to get from API.
const getSeason = (date: Date): string => {
  const normalizedDate = startOfDay(date)
  const year = getYear(date)

  const saturdayWeek18 = dateFromDayOfWeek(year, 18, 6)
  const fridayWeek44 = dateFromDayOfWeek(year, 44, 5)

  if (
    (isAfter(normalizedDate, saturdayWeek18) ||
      isEqual(normalizedDate, saturdayWeek18)) &&
    (isBefore(normalizedDate, fridayWeek44) ||
      isEqual(normalizedDate, fridayWeek44))
  ) {
    return `Summer ${year}`
  }

  const winterStartYear = isBefore(normalizedDate, fridayWeek44)
    ? year - 1
    : year
  const winterEndYear = winterStartYear + 1
  return `Winter ${winterStartYear}-${winterEndYear}`
}

const dateFromDayOfWeek = (
  year: number,
  week: number,
  dayOfWeek: number
): Date => {
  let d = new Date()
  d = setYear(d, year)
  d = setISOWeek(d, week)
  d = setISODay(d, dayOfWeek)
  return startOfDay(d)
}

export const getIsSummer = (date: Date): boolean =>
  getSeason(date).startsWith("Summer")

export default getSeason
